(function() {
	angular.module('ShargoApp')
		.controller('HomeController', function($scope, $rootScope, $timeout, $window, $q, Configuration, deviceDetector, toolsService){
			$rootScope.pageConfiguration = {
				footer: true,
				header: {
					solid: $window.innerHeight - 115,
					background: 'linear-gradient(to bottom, #fed256, #ffbd4d)',
					preheader: true,
					headerLink: $rootScope.url('home'),
					headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg",
					logIn: true,
					dashboard: true,
					callToAction: {
						link: $rootScope.device.isDesktop ? $rootScope.url('sendpackage') : $rootScope.url('contact'),
						text: $rootScope.device.isDesktop ? 'header.ask4Shargo' : 'header.contact',
						target: '',
						hide: true,
						disabled: false
					},
					profile: true
				}
			};

			/* --VARIABLES-- */
			var window = angular.element($window);
			$scope.downloadAppUrl = "home.download-app-android";
			$scope.shargoMobileUrl = "home.shargo-mobile";
			$scope.transportsSelected = [false, false, true, false];
			$scope.stepsPopUp = $scope.stepsPopUpForced = false;
			$scope.logoSelected = 0;

			$scope.transportsSlides = [
				{
					"image"	: Configuration.siteDomain + "/img/bike.png",
					"others": "home.section2-others",
					"price"	: "4€"
				},
				{
					"image"	: Configuration.siteDomain + "/img/moto.png",
					"others": "home.section2-others",
					"price"	: "4€"
				},
				{
					"image"	: Configuration.siteDomain + "/img/car.png",
					"others": "home.section2-others",
					"price"	: "7€"
				},
				{
					"image"	: Configuration.siteDomain + "/img/van.png",
					"others": "home.section2-others",
					"price"	: "15€"
				}
			];

			$scope.stepsSlides = [
				{
					"image"		: Configuration.siteDomain + "/img/Step1.png",
					"title"		: "home.section3-step1-1",
					"subtitle"	: "home.section3-step1-2"
				},
				{
					"image"		: Configuration.siteDomain + "/img/Step2.png",
					"title"		: "home.section3-step2-1",
					"subtitle"	: "home.section3-step2-2"
				},
				{
					"image"		: Configuration.siteDomain + "/img/Step3.png",
					"title"		: "home.section3-step3-1",
					"subtitle"	: "home.section3-step3-2"
				}
			];

			$scope.servicesSlides = [
				{
					"image": Configuration.siteDomain + "/img/svg/service1.svg",
					"src": Configuration.siteDomain + "/img/svg/serviceSlide1.svg",
					"title": "home.section4-service1-1",
					"subtitle": "home.section4-service1-2"
				},
				{
					"image": Configuration.siteDomain + "/img/svg/service2.svg",
					"src": Configuration.siteDomain + "/img/svg/serviceSlide2.svg",
					"title": "home.section4-service2-1",
					"subtitle": "home.section4-service2-2"
				},
				{
					"image": Configuration.siteDomain + "/img/svg/service3.svg",
					"src": Configuration.siteDomain + "/img/svg/serviceSlide3.svg",
					"title": "home.section4-service3-1",
					"subtitle": "home.section4-service3-2"
				},
				{
					"image": Configuration.siteDomain + "/img/svg/service4.svg",
					"src": Configuration.siteDomain + "/img/svg/serviceSlide4.svg",
					"title": "home.section4-service4-1",
					"subtitle": "home.section4-service4-2"
				},
				{
					"image": Configuration.siteDomain + "/img/svg/service5.svg",
					"src": Configuration.siteDomain + "/img/svg/serviceSlide5.svg",
					"title": "home.section4-service5-1",
					"subtitle": "home.section4-service5-2"
				},
				{
					"image": Configuration.siteDomain + "/img/svg/service6.svg",
					"src": Configuration.siteDomain + "/img/svg/serviceSlide6.svg",
					"title": "home.section4-service6-1",
					"subtitle": "home.section4-service6-2"
				}
			];
			$scope.servicesSlidesOptions = {
				sourceProp: 'src',
				perspective: 1,
				startSlide: 0,
				border: 0,
				width: 0,
				height: 0,
				dir: 'rtl',
				loop: true,
				autoRotationSpeed: 0,
				animationSpeed: 250,
				space: 160,
				visible: 3
			};

			$scope.opinionsSlides = [
				{
					"image"		: Configuration.siteDomain + "/img/opinion-image-1.png",
					"title"		: "home.section5-opinion1-1",
					"subtitle"	: "home.section5-opinion1-2",
					"content"	: "home.section5-opinion1-3"
				},
				{
					"image"		: Configuration.siteDomain + "/img/opinion-image-2.png",
					"title"		: "home.section5-opinion2-1",
					"subtitle"	: "home.section5-opinion2-2",
					"content"	: "home.section5-opinion2-3"
				},
				{
					"image"		: Configuration.siteDomain + "/img/opinion-image-3.png",
					"title"		: "home.section5-opinion3-1",
					"subtitle"	: "home.section5-opinion3-2",
					"content"	: "home.section5-opinion3-3"
				},
				{
					"image"		: Configuration.siteDomain + "/img/opinion-image-4.png",
					"title"		: "home.section5-opinion4-1",
					"subtitle"	: "home.section5-opinion4-2",
					"content"	: "home.section5-opinion4-3"
				}
			];
			// Configuration.siteDomain + "/img/logo-1.png",
            $scope.clientsLogos = [
                Configuration.siteDomain + "/img/logos/restoin.png",
                Configuration.siteDomain + "/img/logos/nostrum.png",
                Configuration.siteDomain + "/img/logos/felix.png",
                Configuration.siteDomain + "/img/logos/rodilla.png",
                Configuration.siteDomain + "/img/logos/angrup.png",
                Configuration.siteDomain + "/img/logos/manzaning.png",
                Configuration.siteDomain + "/img/logos/hawkers.png",
                Configuration.siteDomain + "/img/logos/privalia.png",
                Configuration.siteDomain + "/img/logos/laperla.png",
                Configuration.siteDomain + "/img/logos/zatro.png",
                Configuration.siteDomain + "/img/logos/opticau.png",
                Configuration.siteDomain + "/img/logos/floraqueen.png",
                Configuration.siteDomain + "/img/logos/ukeflors.png",
                Configuration.siteDomain + "/img/logos/fotawa.png",
                Configuration.siteDomain + "/img/logos/gruponomo.png",
                Configuration.siteDomain + "/img/logos/laagam.png",
                Configuration.siteDomain + "/img/logos/matias.png",
                Configuration.siteDomain + "/img/logos/merces.png",
                Configuration.siteDomain + "/img/logos/pideycome.png",
                Configuration.siteDomain + "/img/logos/regia.png",
                Configuration.siteDomain + "/img/logos/saladmarket.png",
                Configuration.siteDomain + "/img/logos/tento.png"
            ];
			$scope.newsletter = {
				send: false,
				email: "",
				terms: false,
				button: "../img/svg/radio-button-empty.svg",
				check: {
					email: "",
					terms: ""
				}
			};

			$scope.selectTransport = selectTransport;
			$scope.goDown = goDown;
			$scope.setPositions = setPositions;
			$scope.animateElementIn = animateElementIn;
			$scope.animateTransportsIn = animateTransportsIn;
			$scope.animateOpinionsIn = animateOpinionsIn;
			$scope.actualizeNewsletter = actualizeNewsletter;
			$scope.confirmNewsletter = confirmNewsletter;
			$scope.clickoutStepsPopUp = clickoutStepsPopUp;
			$scope.clickStepsPopUp = clickStepsPopUp;

			$scope.auxPercent = "0.75";


			/* --FUNCTIONS-- */
			function clickoutStepsPopUp(){
				$scope.stepsPopUp = $scope.stepsPopUpForced;
				$scope.stepsPopUpForced = false;
			}

			function clickStepsPopUp(){
				$scope.stepsPopUp = $scope.stepsPopUpForced = true;
				$timeout(function () {
					angular.element('.steps-content').flickity('resize');
				});
			}
			function actualizeNewsletter() {
				toolsService.setFalse($scope.newsletter.check);
				$scope.newsletter.button = $scope.newsletter.button === "../img/svg/radio-button-empty.svg" ? "../img/svg/radio-button-fill.svg" : "../img/svg/radio-button-empty.svg";
				$scope.newsletter.terms = !$scope.newsletter.terms;
			}
			
			function confirmNewsletter() {
				if (!$scope.newsletter.terms) {
					$scope.newsletter.check.terms = "home.last-section-error-terms";
				}
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				if (!$scope.newsletter.email || !re.test($scope.newsletter.email)) {
					$scope.newsletter.check.email = "home.last-section-error-email";
				}
				if (!toolsService.allFalse($scope.newsletter.check)) {
					HomeService.addNewsletter($scope.newsletter.email)
						.then(function (response) {
							$scope.newsletter.send = true;
						})
						.catch(function (error) {
							$scope.newsletter.check.email = "home.last-section-error-email";
							console.log("ERROR IN HOME NEWSLETTER: ", error);
						});
				}
			}
			
			function selectTransport(i, j) {
				for(var k = 0; k < $scope.transportsSelected.length; ++k) {
					$scope.transportsSelected[k] = false;
				}
				$scope.transportsSelected[i*2 + j] = !$scope.transportsSelected[i*2 + j];
			}

			function goDown() {
				angular.element("body").animate({scrollTop: $window.innerHeight - 115}, "slow");
			}

			function animateElementIn($el) {
				$el.removeClass('not-visible');
				$el.addClass('animated');
			}

			var firstTime = true;
			function animateTransportsIn($el) {
				animateElementIn($el);
				if ($rootScope.device.isPhone && firstTime) {
					firstTime = false;
				}
			}

			var firstOpinionsTime = true;
			function animateOpinionsIn($el) {
				animateElementIn($el);
				if (firstOpinionsTime) {
					firstOpinionsTime = false;
				}
			}

			function setPositions() {
				var top = angular.element(".full-screen-image .buttons-header-container").position().top;
				var height = angular.element(".full-screen-image .buttons-header-container")[0].offsetHeight;
				angular.element(".full-screen-image .logos-container").css("top", angular.element(".full-screen-image")[0].offsetHeight - 60 - top - height);
				/*
				if ($rootScope.device.isPhone) {
					var top = angular.element("#homepage-download-button").position().top;
					var height = angular.element("#homepage-download-button")[0].offsetHeight;
					angular.element(".interactive-mobile").css("top", top + height + 30 + "px");
					angular.element(".interactive-mobile").css("max-width", $window.innerWidth);
					//top = top + height + 50; height = 610;
					top = angular.element(".interactive-mobile").position().top;
					height = angular.element(".interactive-mobile")[0].offsetHeight;
					angular.element(".home-content").css("top", top + height + 70 + "px");
				}
				else {
					var top = angular.element(".full-screen-image").position().top;
					var height = angular.element(".full-screen-image")[0].offsetHeight;
					angular.element(".home-content").css("top", top + height + "px");
				}
				*/
			}

			function updateLogoSelected(){
				$timeout(function () {
					$scope.logoSelected++;
					if ($scope.logoSelected === 3) {
						$scope.logoSelected = 0;
					}
					updateLogoSelected();
				}, 3000);
			}

			function init() {
				var positionInital = $rootScope.device.isVertical;
				if ($rootScope.device.os === "ios") {
					$scope.downloadAppUrl = "home.download-app-ios";
				}
				else {
					$scope.downloadAppUrl = "home.download-app-android";
				}

				window.bind('resize', function () {
					if ($scope.pageKey.name === "home") {
						if($rootScope.device.isDesktop || positionInital !== $rootScope.device.isVertical){
							positionInital = $rootScope.device.isVertical;
							imageHeight = $window.innerHeight;
							if (!$scope.cookiesAreAcceppted) {
								imageHeight += -angular.element(".cookie-cont")[0].offsetHeight;
							}
							angular.element(".full-screen-image").css("height", imageHeight);
							angular.element(".home-container").css("width", $window.innerWidth);
							setPositions();
						}
					}
				});

				setPositions();

				if ($rootScope.device.isPhone) {
					angular.element('.steps-content').flickity({
						adaptiveHeight: false,
						wrapAround: true,
						pageDots: false
					});

					angular.element('.opinions-content').flickity({
						adaptiveHeight: false,
						wrapAround: true,
						prevNextButtons: false
					});

					updateLogoSelected();
				}
				else {
					angular.element('.opinions-content').flickity({
						adaptiveHeight: false,
						wrapAround: true
					});
				}
				angular.element('.opinions-content').flickity('resize');
			}

			function waitUntilPageLoaded() {
				var deferred = $q.defer();
				var checkExist = setInterval(function() {
					if ($scope.pageKey.name === "home"){
						if (angular.element(".full-screen-image").length && angular.element(".full-screen-image")[0] &&
							angular.element(".full-screen-image")[0].offsetHeight > 0) {
								clearInterval(checkExist);
								deferred.resolve();
						}
					}
					else {
						clearInterval(checkExist);
						deferred.reject();
					}
				}, 100);
				return deferred.promise;
			}


			/* --EXECUTION-- */
			angular.element(document).ready(function () {
				$timeout(function(){
					var imageHeight = $window.innerHeight;
					if (!$scope.cookiesAreAcceppted) {
						imageHeight += -angular.element(".cookie-cont")[0].offsetHeight;
					}
					angular.element(".full-screen-image").css("height", imageHeight);
					angular.element(".home-container").css({"width": $window.innerWidth, "display": "block"});
					//angular.element(".header").css("display", "block");
					waitUntilPageLoaded().then(function (res) {
						init();
					});
				});
			});
		});
})();